import { ROUTE_PATH } from 'app/lib/routing/constants';

export const getCreativeSlotByPathname = (pathname: string) => {
  switch (pathname) {
    case ROUTE_PATH.ROOT:
      return 'main_carousel';
    case ROUTE_PATH.PROMOTIONS:
      return 'page_promo';
    default:
      return '';
  }
};

